module.exports = __webpack_public_path__ + "img/head-mv02.2553dce3.jpg";